import React from 'react';
import { BloodPressureReadingPositionType } from '~/services/api/enums';
import { ReactComponent as StandingIcon } from './icons/Standing.svg';
import { ReactComponent as SittingIcon } from './icons/Sitting.svg';
import { ReactComponent as LayingIcon } from './icons/Laying.svg';

export const POSITION_ICONS_MAP: Record<
  BloodPressureReadingPositionType,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  [BloodPressureReadingPositionType.Standing]: StandingIcon,
  [BloodPressureReadingPositionType.Sitting]: SittingIcon,
  [BloodPressureReadingPositionType.Laying]: LayingIcon,
};
export default {};
